import { render, staticRenderFns } from "./ShopBackView.vue?vue&type=template&id=60762d3f&scoped=true"
import script from "./ShopBackView.vue?vue&type=script&lang=js"
export * from "./ShopBackView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60762d3f",
  null
  
)

export default component.exports